import translateTexts from './translateTexts';

export default {
  translateTexts,
};